import { Chip, Box, Typography } from "@wealthx/ui";
import React, { useState } from "react";
import { ButtonBase, Popover } from "@mui/material";

import { PolicySource } from "../../type/chat";

import "./citation-badge.scss";

interface CitationBadgeProps {
  index: number;
  source: PolicySource;
}

const CitationBadge: React.FC<CitationBadgeProps> = ({ index, source }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <ButtonBase
        className="citation-badge"
        onClick={handleClick}
        aria-label={`View source ${index}: ${source.bank} ${source.category}`}
      >
        [{index}]
      </ButtonBase>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transformOrigin={{ vertical: "bottom", horizontal: "center" }}
        slotProps={{
          paper: {
            className: "citation-popover",
          },
        }}
      >
        <Box className="citation-popover__content">
          <Box className="citation-popover__header">
            <Typography className="citation-popover__category">{source.category}</Typography>
            <Chip label={source.bank} size="small" className="citation-popover__bank" />
          </Box>
          <Typography variant="body2" className="citation-popover__text">
            {source.text}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};

export default CitationBadge;
